















import { Session } from '../../utils/Session';
import { MessageDialog } from '../../utils/MessageDialog';
import { Vue, Component } from 'vue-property-decorator';
import MenuButton from './MenuButton.vue';
import { routeHelper } from '../../utils/routeHelper';

@Component({ components: { MenuButton } })
export default class TeacherDashboadMenu extends Vue {
  click(name: string) {
    if (!Session.isProfielComplete()) {
      MessageDialog.alertModal('プロフィール入力を完了することで、全ての機能が使えるようになります');
      return;
    }
    routeHelper(this, name);
  }
}
